import React, { useState, useEffect } from 'react'
import FilterLazeCutting from './FilterLazeCutting'
import { Pagination } from 'antd'
import LazeCuttingTable from './table/LazeCuttingTable'
import { getListBatchesCutting, exportBatchesCutting } from '../../../services/api/3dApi'
import { _convertObject } from "../../../helpers/convertObject"
import moment from "moment"
import { NavLink } from 'react-router-dom'
import { getLocalData } from '../../../services/StorageServices'


const ListLazeCuttingPage = (props) => {

    const { setIsLaze, isLaze } = props
    const [listBatches, setListBatches] = useState([])
    const [name, setName] = useState('')
    const [productTypes, setProductTypes] = useState([])
    const [usersCut, setUsersCut] = useState([])
    const [startCuttingAt, setStartCuttingAt] = useState("")
    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(50)
    const [total, setTotal] = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState('')


    const _handleChangeProductType = value => {
        setProductTypes(value)
        setPage(1)
    }

    const _handleChangeUsersCut = value => {
        setUsersCut(value)
        setPage(1)
    }

    const _handleChangeDate = filter => {
        setStartCuttingAt({ ...filter })
        setPage(1)
    }

    const _handleChangeInput = (value) => {
        setName(value)
        setPage(1)
    }

    const _handlePageChange = page => {
        setPage(page)
    }

    const _handleShowSizeChange = (current, size) => {
        setLimit(size)
        setPage(1)
    }

    const refreshLazeCut = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                page, limit, name, productTypes, cutter_name: usersCut
            }

            if (startCuttingAt.created_at) {
                payload.startCuttingAt = startCuttingAt.created_at.date
                payload.startCuttingAtTime = startCuttingAt.created_at.time
            }

            const { data: results } = await getListBatchesCutting(payload)
            const { data, success, error } = Object.assign({}, results)

            if (!success) return setError(error)

            const { batches, total } = data
            setListBatches(batches)
            setTotal(total)
            setLoading(false)

        } catch (error) {
            setError(error)
        }
    }

    const _exportAllItemBatches = async () => {
        setLoading(true)
        setError('')

        try {
            const payload = {
                productTypes,
                cutter_name: usersCut,
                name: name
            }

            if (startCuttingAt.created_at) 
            {
                payload.startCuttingAt = startCuttingAt.created_at.date
                payload.startCuttingAtTime = startCuttingAt.created_at.time
            }

            const newFilter = _convertObject(payload)

            const { data } = await exportBatchesCutting(newFilter)
            if (data) {
                let csvFile
                let downloadLink

                const start = moment(Date.now()).format('YYYY/MM/DD')
                csvFile = new Blob([data], { type: 'text/csv;encoding:utf-8' })
                downloadLink = document.createElement('a')
                downloadLink.download = `items_batches_cut_${start}`
                downloadLink.href = window.URL.createObjectURL(csvFile)
                downloadLink.style.display = 'none'
                document.body.appendChild(downloadLink)
                downloadLink.click()
                document.body.removeChild(downloadLink)
            }

            setLoading(false)

        } catch (e) {
            setError(e.message)
            setLoading(false)
        }
    }

    useEffect(() => {
        refreshLazeCut()

    }, [page, limit, name, productTypes, startCuttingAt, usersCut])

    const userRole = getLocalData('userRole')
    const {
        request_update,
        base_cost_management,
        permission_management,
        role_management,
        user_action_management,
        user_management,
    }= {...userRole}
    const adminRole = !!request_update && !! base_cost_management && !!permission_management && !!role_management && !!user_action_management && !!user_management

    return (
        <div className="ListLazeCuttingPage">
            <div className="container-fluid min-vh-100">
                <div className="col-12 mx-auto bg-white shadow-sm py-3 px-0 px-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex align-items-center justify-content-between mb-3">
                            <h3 className="m-0">Danh sách cắt laze</h3>
                        </div>
                        <div>
                            {adminRole&&
                                <button type="button" className="ant-btn ant-btn-primary mx-4" onClick={_exportAllItemBatches}><span>Export item</span></button>
                            }

                            <button type="button" className="ant-btn bg-white">
                                <NavLink exact to='/laze-cutting' className='nav-link p-0'>
                                    Đánh dấu cắt laze
                                </NavLink>
                            </button>
                        </div>
                    </div>

                    <div className="jumbotron px-3 pb-0 pt-3 mb-3">
                        <FilterLazeCutting
                            startCuttingAt={startCuttingAt}
                            productTypes={productTypes}
                            onChangeProductType={_handleChangeProductType}
                            usersCut={usersCut}
                            onChangeUsersCut={_handleChangeUsersCut}
                            loading={loading}
                            handleChangeDate={_handleChangeDate}
                            handleChangeInput={_handleChangeInput}
                        />
                    </div>

                    <div className="d-flex justify-content-between align-items-center mb-3 headPagination">
                        <div>
                            {error && (
                                <div className="text-danger mb-2">{error}</div>
                            )}
                        </div>
                        <Pagination current={page} total={total} pageSize={limit}
                            showTotal={(sum, range) => sum > 0 &&
                                <div>{`Hiển thị ${range[0]} đến ${range[1]} của `}<strong>{`${total} lô hàng`}</strong>
                                </div>}
                            onChange={_handlePageChange}
                            className='text-right' showSizeChanger
                            pageSizeOptions={['10', '20', '50', '100']}
                            onShowSizeChange={_handleShowSizeChange} />
                    </div>

                    <div className="LazeCuttingTable">
                        <LazeCuttingTable
                            listBatches={listBatches}
                            loading={loading}
                            onChangeProductType={_handleChangeProductType}
                            adminRole={adminRole}
                        />
                    </div>

                    <Pagination
                        current={page} total={total} pageSize={limit}
                        onChange={_handlePageChange}
                        showQuickJumper
                        className='CustomPagination text-right' showSizeChanger
                        pageSizeOptions={['10', '20', '50', '100']}
                        onShowSizeChange={_handleShowSizeChange}
                    />
                </div>
            </div>
        </div>
    )
}

export default ListLazeCuttingPage